import React, { useState, useRef } from 'react';
import { Drawer, Box } from '@mui/material';
import arrow from '../../assets/arrow.png';
import cltLogo from '../../assets/JORNAYLogo.png';
import bottomimg from '../../assets/Collegium_rgb logo.png';
import upImg from '../../assets/up.png';

const ISI = () => {
  const [open, setOpen] = useState(false);
  const drawerRef = useRef(null);

  const toggleDrawer = (open) => () => {
    setOpen(open);
  };

  const scrollToTop = () => {
    console.log(drawerRef);
    if (drawerRef.current) {
      drawerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="isi-comp" style={{ display: open ? 'none' : '' }}>
      <div className="isi-footer">
        <div className={`isi-background open`}>
          <div className="isi-wording-wrapper open">
            <div className="isi-wording-title-top">
              <div className="isi-wording-left-words">
                <p style={{ color: 'black', fontWeight: 'bold' }}>
                  Click below for additional Important Safety Information, including Boxed Warning.
                </p>
              </div>
              <img src={cltLogo} alt="logo" />
            </div>
            <div className="isi-bottom-open-button">
              <div className="isi-button" onClick={toggleDrawer(true)}>
                IMPORTANT SAFETY INFORMATION <img src={arrow} alt="arrow" />
              </div>
              <div className="isi-closed-boxed" style={{ fontWeight: 'bold' }}>
                <h2 style={{ textAlign: 'center' }}>BOXED WARNING: ABUSE, MISUSE, AND ADDICTION</h2>
                JORNAY PM has a high potential for abuse and misuse, which can lead to the development of a substance
                use disorder, including addiction. Misuse and abuse of CNS stimulants, including JORNAY PM, can result
                in overdose and death, and this risk is increased with higher doses or unapproved methods of
                administration, such as snorting or injection.
              </div>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            // backgroundColor: 'transparent',
            // padding: '0 10px',
            height: '100dvh',
            overflow: 'hidden'
          }
        }}
      >
        <Box
          ref={drawerRef}
          sx={{
            backgroundColor: '#D9D9D9',
            width: '100%',
            maxWidth: '800px',
            margin: '0 auto',
            // padding: '20px',
            display: 'flex',
            height: '100%',
            borderRadius: '20px',
            borderBottomLeftRadius: '0',
            borderBottomRightRadius: '0',
            alignItems: 'center',
            // height: '400px',
            flexDirection: 'column',
            overflowY: 'auto'
          }}
        >
          <Box
            sx={{
              backgroundColor: '#FFFFFF',
              // width: '100%',
              // width: '95%',
              // padding: '16px',
              // paddingBottom: '80px',
              borderRadius: '8px'
            }}
          >
            <Box
              sx={{
                // width: '100%',
                // width: '95%',
                // padding: '16px',
                height: '100%',
                borderRadius: '8px'
              }}
            >
              <div className="isi-title" onClick={toggleDrawer(false)}>
                Important Safety Information <img src={arrow} alt="arrow" style={{ transform: 'rotate(180deg)' }} />
              </div>
              <div>
                <div className="isi-body">
                  <h2>IMPORTANT SAFTEY INFORMATION</h2>
                  <div className="no-bullet boxed" style={{ fontWeight: 'bold' }}>
                    <h2 style={{ textAlign: 'center' }}>BOXED WARNING: ABUSE, MISUSE, AND ADDICTION</h2>
                    JORNAY PM has a high potential for abuse and misuse, which can lead to the development of a
                    substance use disorder, including addiction. Misuse and abuse of CNS stimulants, including JORNAY
                    PM, can result in overdose and death, and this risk is increased with higher doses or unapproved
                    methods of administration, such as snorting or injection.
                    <br />
                    Before prescribing JORNAY PM, assess each patient’s risk for abuse, misuse, and addiction. Educate
                    patients and their families about these risks, proper storage of the drug, and proper disposal of
                    any unused drug. Throughout JORNAY PM treatment, reassess each patient’s risk of abuse, misuse, and
                    addiction and frequently monitor for signs and symptoms of abuse, misuse and addiction.
                  </div>
                  <h2>CONTRAINDICATIONS</h2>
                  <p>
                    Known hypersensitivity to methylphenidate or other components of JORNAY PM. Hypersensitivity
                    reactions such as angioedema and anaphylactic reactions have been reported in patients treated with
                    methylphenidate products.
                  </p>
                  <p>
                    Concurrent treatment with a monoamine oxidase inhibitor (MAOI), or use of an MAOI within the
                    preceding 14 days because of the risk of hypertensive crisis.{' '}
                  </p>
                  <h2>WARNINGS AND PRECAUTIONS</h2>
                  <span className="italic">
                    JORNAY PM can cause serious adverse reactions and patients should be monitored for the following:
                  </span>
                  <p>
                    <span className="italic">Risks to Patients with Serious Cardiac Disease</span>: Sudden death has
                    been reported in patients with structural cardiac abnormalities or other serious cardiac disease who
                    were treated with CNS stimulants at the recommended ADHD dosage. Avoid use in patients with known
                    structural cardiac abnormalities, cardiomyopathy, serious cardiac arrhythmia, coronary artery
                    disease, or other serious cardiac disease.
                  </p>
                  <p className="italic">Increased Blood Pressure and Heart Rate.</p>
                  <p>
                    <span className="italic">Psychiatric Adverse Reactions</span>: Including exacerbation of behavior
                    disturbance and thought disorder in patients with a pre-existing psychotic disorder, induction of a
                    manic episode in patients with bipolar disorder, and new psychotic or manic symptoms. Prior to
                    initiating treatment, screen patients for risk factors for psychiatric adverse reactions. If such
                    symptoms occur, consider discontinuing JORNAY PM.
                  </p>
                  <p>
                    <span className="italic">Priapism</span>: Patients should seek immediate medical attention.
                  </p>
                  <p>
                    <span className="italic">Peripheral Vasculopathy, including Raynaud’s Phenomenon</span>: Observe
                    patients for digital changes during treatment.
                  </p>
                  <p>
                    <span className="italic">
                      Weight Loss and Long-Term Suppression of Growth in Pediatric Patients
                    </span>
                    : Monitor height and weight.
                  </p>
                  <p>
                    <span className="italic">Increased Intraocular Pressure (IOP) and Glaucoma</span>: Patients at risk
                    for acute angle closure glaucoma should be evaluated by an ophthalmologist. Closely monitor patients
                    with a history of abnormally increased IOP or open angle glaucoma.
                  </p>
                  <p className="italic">
                    Onset or Exacerbation of Motor and Verbal Tics and Worsening of Tourette’s Syndrome.
                  </p>
                  <h2>ADVERSE REACTIONS</h2>
                  <p>
                    The most common (≥5% and twice the rate of placebo) adverse reactions with methylphenidate are
                    decreased appetite, insomnia, nausea, vomiting, dyspepsia, abdominal pain, decreased weight,
                    anxiety, dizziness, irritability, affect lability, tachycardia, and increased blood pressure.
                  </p>
                  <p>
                    Additional adverse reactions (≥5% and twice the rate of placebo) in JORNAY PM-treated pediatric
                    patients 6 to 12 years are headache, psychomotor hyperactivity, and mood swings.
                  </p>
                  <h2>DRUG INTERACTIONS</h2>
                  <p>
                    Antihypertensive drugs: Monitor blood pressure; adjust dosage of antihypertensive drug as needed.
                  </p>
                  <div className="isi-bottom">
                    <span style={{ fontWeight: 'bold' }}>
                      To report SUSPECTED ADVERSE REACTIONS, contact Collegium Pharmaceutical, Inc. at 1-855-331-5615 or
                      FDA at 1-800-FDA-1088 or{' '}
                      <a href="http://www.fda.gov/medwatch" target="__blank">
                        www.fda.gov/medwatch
                      </a>
                      .
                    </span>
                    <h2>INDICATION</h2>
                    <p className="no-bullet">
                      JORNAY PM (methylphenidate HCl extended-release capsules) is a central nervous system (CNS)
                      stimulant indicated for the treatment of Attention Deficit Hyperactivity Disorder (ADHD) in
                      patients 6 years and older.
                    </p>
                    <span style={{ fontWeight: 'bold' }}>
                      Please{' '}
                      <a href="https://www.collegiumpharma.com/wp-content/uploads/JORNAY_PM_Label.pdf" target="__blank">
                        click here
                      </a>{' '}
                      for Full Prescribing Information, including Boxed Warning.{' '}
                    </span>
                  </div>
                </div>
                <div className="isi-wording-wrapper">
                  <div className="isi-wording-title">
                    <img src={bottomimg} alt="logo" />
                  </div>
                  <div className="isi-wording-body">
                    <p className="no-bullet" style={{ fontWeight: 'bold', marginTop: 5 }}>
                      ©2025 Collegium Pharmaceutical, Inc. All rights reserved.
                    </p>
                    <p className="no-bullet">100 Technology Center Dr #300, </p>
                    <p className="no-bullet">Stoughton, MA 02072</p>
                    <p className="no-bullet" style={{ textDecoration: 'underline', marginTop: 5 }}>
                      <a href="https://www.jornaypm-pro.com/" target="__blank">
                        https://www.jornaypm-pro.com/
                      </a>
                    </p>
                    <p className="no-bullet">PP-JNY-US-0431 06/25</p>
                    <img src={upImg} alt="up" className="arrow-up" onClick={() => scrollToTop()} />
                  </div>
                </div>
              </div>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </div>
  );
};

export default ISI;
